<div class="modal-md ship-to">
  <div class="modal-header state">
    <!--        <h1 class="full-width text-align-center">Ship To Attention</h1>-->
    <button
      type="button"
      (click)="close()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body sustainable">
    <h1 class="full-width text-align-center">{{ title }}</h1>
    <div class="mt-4 text-align-center">
      <p class="description" [innerHTML]="content | safeContent"></p>
    </div>
    <div class="my-4 text-align-center">
      <button
        class="btn btn-primary control"
        type="button"
        (click)="redirect()"
      >
        Learn More
      </button>
    </div>
  </div>
</div>
